import { COLORS } from "../../../../Diathrive/src/utils/Constants";

const styles = {
  container: {
    display: "flex",
  },
  mainPannel: {
    // should be replace with current one when next appointments is enabled.
    width: "70%",
    // width: "100%",
  },
  homeRightPannel: {
    width: "30%",
    background: COLORS.white,
    borderLeft: "1px solid #E0E4ED",
    display: "grid",
    paddingLeft: "30px",
    paddingRight: "30px",
    paddingTop: "32px",
    gap: "25%",
  },
  noAppointmentsText: {
    textAlign: "center",
  },
};

export default styles;
